import { render, staticRenderFns } from "./HealthStatusListEditDialog.vue?vue&type=template&id=2b0ed492&scoped=true&"
import script from "./HealthStatusListEditDialog.vue?vue&type=script&lang=js&"
export * from "./HealthStatusListEditDialog.vue?vue&type=script&lang=js&"
import style0 from "./HealthStatusListEditDialog.vue?vue&type=style&index=0&id=2b0ed492&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0ed492",
  null
  
)

export default component.exports